import React from 'react';
import { Box, Typography } from '@mui/material';
import TaskingStripThumbnail from './TaskingStripThumbnail';

const formatDisplayTime = (timestamp, timezoneLabel = 'UTC') => {
  if (!timestamp) return 'N/A';
  try {
    const date = new Date(timestamp.replace(' ', 'T'));
    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };
    return `${date.toLocaleString('en-GB', options)} ${timezoneLabel}`;
  } catch (err) {
    return `${timestamp} ${timezoneLabel}`;
  }
};

const TaskingStripCard = ({ strip, isSelected, onSelect }) => {
  return (
    <Box
      onClick={(event) => {
        event.stopPropagation();
        onSelect?.(strip);
      }}
      sx={{
        display: 'flex',
        gap: 0.65,
        alignItems: 'center',
        p: 0.65,
        borderRadius: 1.25,
        border: isSelected ? '1px solid #5d9dff' : '1px solid #282d36',
        bgcolor: '#1c2029',
        cursor: 'pointer',
        transition: 'border 0.2s ease, background 0.2s ease',
        '&:hover': {
          borderColor: '#76b6ff',
          bgcolor: '#1f242e',
        },
        boxShadow: '0px 4px 10px rgba(0,0,0,0.18)',
      }}
    >
      <TaskingStripThumbnail coordinates={strip.coordinates} color={strip.color} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0, flex: 1, minWidth: 0 }}>
        <Typography sx={{ color: '#F4F6FA', fontSize: '11px', fontWeight: 600, lineHeight: '15px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {strip.passLabel}
        </Typography>
        <Typography sx={{ color: '#A6B6CE', fontSize: '10px', lineHeight: '15px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {strip.satelliteId && strip.satelliteId !== strip.satelliteLabel 
            ? `${strip.satelliteLabel} • ${strip.satelliteId}` 
            : strip.satelliteLabel}
        </Typography>
        <Typography sx={{ color: '#D3DAE8', fontSize: '9.5px', lineHeight: '13px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {formatDisplayTime(strip.access_start, strip.timezoneLabel)}
        </Typography>
        {strip.viewingAngle != null && !Number.isNaN(Number(strip.viewingAngle)) && (
          <Typography
            sx={{
              color: '#A6B6CE',
              fontSize: '9px',
              lineHeight: '13px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {`Off-nadir: ${Number(strip.viewingAngle).toFixed(1)}°`}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default TaskingStripCard;

